import { type RootState } from '../../../lib/store';

export const selectProjectsListPage = (state: RootState) =>
  state.supervisorProject?.projectsListPage ?? 0;
export const selectProjectsListPageSize = (state: RootState) =>
  state.supervisorProject?.projectsListPageSize ?? 25;
